import {FC} from 'react'

/**
 * Small "×" icon used inside tag/chip remove (and cancel) buttons across the
 * onboarding wizard. Rendered as an SVG rather than the "×" character so it stays
 * perfectly centered inside its (often circular) button regardless of font metrics.
 * Uses `currentColor`, so it inherits the button's text color and hover states.
 */
const TagRemoveIcon: FC<{size?: number}> = ({size = 8}) => (
  <svg width={size} height={size} viewBox='0 0 8 8' fill='none' aria-hidden='true'>
    <path d='M1 1L7 7M7 1L1 7' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' />
  </svg>
)

export default TagRemoveIcon
